// import { createSlice } from '@reduxjs/toolkit';

// // Helper function to get user from localStorage
// const getUserFromStorage = () => {
//   try {
//     const token = localStorage.getItem('auth_token');
//     const id = localStorage.getItem('user_id');
//     const email = localStorage.getItem('user_email');
//     const name = localStorage.getItem('user_name');
    
//     if (token && id) {
//       return {
//         id: parseInt(id),
//         email: email || '',
//         fullName: name || '',
//         token: token
//       };
//     }
//   } catch (error) {
//     console.error('Error retrieving user from storage:', error);
//   }
//   return null;
// };

// const initialState = {
//   user: getUserFromStorage(),
//   isAuthenticated: !!getUserFromStorage(),
//   properties: [], // Add this to store property IDs
//   subscription: {
//     plan: 'free', // 'free', 'basic', 'professional', 'enterprise'
//     propertiesAdded: 3, // Start with 3 for testing (max free limit)
//     maxProperties: 999, // Free tier allows 3 properties
//     coolingPeriod: null, // Add cooling period tracking
//     listingDuration: null, // Add listing duration tracking
//   },
//   messaging: {
//     currentConversationId: null,
//     conversations: [],
//     senderId: null,
//     receiverId: null // Added receiverId to store
//   },
//   // Add form data storage for login and register forms
//   formData: {
//     login: {
//       email: '',
//       username: '',
//       phone: ''
//     },
//     register: {
//       fullName: '',
//       email: '',
//       username: '',
//       contactNumber: '',
//       address: '',
//       city: '',
//       state: '',
//       zipCode: '',
//       country: '',
//       agreedToTerms: false
//     }
//   },
//   // Add user profile information
//   userProfile: {
//     fullName: '',
//     email: '',
//     contactNumber: '',
//   }
// };

// const userSlice = createSlice({
//   name: 'user',
//   initialState,
//   reducers: {
//     setUser: (state, action) => {
//       // Ensure we have an id in the user object
//       const userData = action.payload;
      
//       // Store the complete user object including id
//       state.user = userData;
//       state.isAuthenticated = !!userData;
      
//       // Store token in localStorage for persistence
//       if (userData && userData.token) {
//         localStorage.setItem('auth_token', userData.token);
//         if (userData.id) {
//           localStorage.setItem('user_id', userData.id.toString());
//         }
//         if (userData.email) {
//           localStorage.setItem('user_email', userData.email);
//         }
//         if (userData.fullName) {
//           localStorage.setItem('user_name', userData.fullName);
//         }
//       }
      
//       // Store user profile information when user logs in
//       if (userData) {
//         state.userProfile = {
//           fullName: userData.fullName || '',
//           email: userData.email || '',
//           contactNumber: userData.contactNumber || '',
//         };
//       }
      
//       // Initialize messaging state if it doesn't exist
//       if (!state.messaging) {
//         state.messaging = {
//           currentConversationId: null,
//           conversations: [],
//           senderId: null,
//           receiverId: null
//         };
//       }
      
//       // Log the user object to console for debugging
//       console.log('User set in Redux:', userData);
//     },
    
//     // NEW: Add Google OAuth specific handler
//     setGoogleUser: (state, action) => {
//       const googleData = action.payload;
      
//       console.log('Setting Google user with data:', googleData);
      
//       // Create user object from Google response
//       const userData = {
//         id: googleData.id,
//         fullName: googleData.full_name,
//         email: googleData.email_id,
//         contactNumber: googleData.contact_number,
//         token: googleData.token || localStorage.getItem('auth_token'),
//         authProvider: googleData.auth_provider || 'google',
//         googleId: googleData.google_id,
//         profileImage: googleData.profile_image,
//         location: googleData.location,
//         occupation: googleData.occupation,
//         professionalTitle: googleData.professional_title,
//         companyName: googleData.company_name,
//         yearsOfExperience: googleData.years_of_experience,
//         licenseNumber: googleData.license_number,
//         bio: googleData.bio,
//         website: googleData.website,
//         linkedin: googleData.linkedin,
//         facebook: googleData.facebook,
//       };
      
//       state.user = userData;
//       state.isAuthenticated = true;
      
//       // Store in localStorage
//       if (userData.token) {
//         localStorage.setItem('auth_token', userData.token);
//       }
//       localStorage.setItem('user_id', userData.id.toString());
//       localStorage.setItem('user_email', userData.email);
//       localStorage.setItem('user_name', userData.fullName);
      
//       // Update user profile
//       state.userProfile = {
//         fullName: userData.fullName,
//         email: userData.email,
//         contactNumber: userData.contactNumber || '',
//       };
      
//       // Initialize messaging state if it doesn't exist
//       if (!state.messaging) {
//         state.messaging = {
//           currentConversationId: null,
//           conversations: [],
//           senderId: null,
//           receiverId: null
//         };
//       }
      
//       console.log('Google user set in Redux:', userData);
//     },
    
//    // UPDATED: Complete logout with full state reset
// logout: (state) => {
//   // Clear ALL localStorage items
//   localStorage.removeItem('auth_token');
//   localStorage.removeItem('user_id');
//   localStorage.removeItem('user_email');
//   localStorage.removeItem('user_name');
  
//   // **IMPORTANT: Return initial state completely**
//   return {
//     user: null,
//     isAuthenticated: false,
//     properties: [],
//     subscription: {
//       plan: 'free',
//       propertiesAdded: 0,
//       maxProperties: 3,
//       coolingPeriod: null,
//       listingDuration: null,
//     },
//     messaging: {
//       currentConversationId: null,
//       conversations: [],
//       senderId: null,
//       receiverId: null
//     },
//     formData: {
//       login: {
//         email: '',
//         username: '',
//         phone: ''
//       },
//       register: {
//         fullName: '',
//         email: '',
//         username: '',
//         contactNumber: '',
//         address: '',
//         city: '',
//         state: '',
//         zipCode: '',
//         country: '',
//         agreedToTerms: false
//       }
//     },
//     userProfile: {
//       fullName: '',
//       email: '',
//       contactNumber: '',
//     }
//   };
// },
    
//     // Add new reducers for subscription management
//     setPlan: (state, action) => {
//       const plan = action.payload;
//       let maxProperties = 3; // Default free tier
//       let listingDuration = 0; // Default free tier
//       let coolingPeriod = 0; // Default free tier
      
//       // Set max properties based on plan
//       switch (plan) {
//         case 'basic':
//           maxProperties = 10;
//           listingDuration = 30; // 30 days
//           coolingPeriod = 30; // 30 days cooling period
//           break;
//         case 'professional':
//           maxProperties = 25;
//           listingDuration = 90; // 90 days
//           coolingPeriod = 30; // 30 days cooling period
//           break;
//         case 'enterprise':
//           maxProperties = 999; // Practically unlimited
//           listingDuration = 180; // 180 days
//           coolingPeriod = 30; // 30 days cooling period
//           break;
//         default:
//           maxProperties = 3; // Free tier
//           listingDuration = 15; // 15 days for free tier
//           coolingPeriod = 0; // No cooling period for free tier
//       }
      
//       state.subscription = {
//         ...state.subscription,
//         plan,
//         maxProperties,
//         listingDuration,
//         coolingPeriod,
//       };
//     },
    
//     incrementPropertyCount: (state) => {
//       state.subscription.propertiesAdded += 1;
//     },
    
//     // Add new reducer for storing property IDs
//     addProperty: (state, action) => {
//       const propertyId = action.payload;
//       if (!state.properties) state.properties = [];
//       state.properties.push(propertyId);
//     },
    
//     // New reducers for messaging
//     setCurrentConversationId: (state, action) => {
//       // Initialize messaging state if it doesn't exist
//       if (!state.messaging) {
//         state.messaging = {
//           currentConversationId: null,
//           conversations: [],
//           senderId: null,
//           receiverId: null
//         };
//       }
//       state.messaging.currentConversationId = action.payload;
//     },
    
//     setSenderId: (state, action) => {
//       // Initialize messaging state if it doesn't exist
//       if (!state.messaging) {
//         state.messaging = {
//           currentConversationId: null,
//           conversations: [],
//           senderId: null,
//           receiverId: null
//         };
//       }
//       state.messaging.senderId = action.payload;
//     },
    
//     setReceiverId: (state, action) => {
//       // Initialize messaging state if it doesn't exist
//       if (!state.messaging) {
//         state.messaging = {
//           currentConversationId: null,
//           conversations: [],
//           senderId: null,
//           receiverId: null
//         };
//       }
//       state.messaging.receiverId = action.payload;
//     },
    
//     setConversations: (state, action) => {
//       // Initialize messaging state if it doesn't exist
//       if (!state.messaging) {
//         state.messaging = {
//           currentConversationId: null,
//           conversations: [],
//           senderId: null,
//           receiverId: null
//         };
//       }
//       state.messaging.conversations = action.payload;
//     },
   
//     setLoginFormData: (state, action) => {
//       state.formData.login = {
//         ...state.formData.login,
//         ...action.payload
//       };
//     },
    
//     setLoginField: (state, action) => {
//       const { field, value } = action.payload;
//       state.formData.login[field] = value;
//     },
    
//     setRegisterFormData: (state, action) => {
//       state.formData.register = {
//         ...state.formData.register,
//         ...action.payload
//       };
      
//       if (action.payload.fullName) {
//         state.userProfile.fullName = action.payload.fullName;
//       }
//       if (action.payload.email) {
//         state.userProfile.email = action.payload.email;
//       }
//       if (action.payload.contactNumber) {
//         state.userProfile.contactNumber = action.payload.contactNumber;
//       }
//     },
    
//     setRegisterField: (state, action) => {
//       const { field, value } = action.payload;
//       state.formData.register[field] = value;
      
//       // Also update userProfile for specific fields
//       if (field === 'fullName') {
//         state.userProfile.fullName = value;
//       } else if (field === 'email') {
//         state.userProfile.email = value;
//       } else if (field === 'contactNumber') {
//         state.userProfile.contactNumber = value;
//       }
//     },
    
//     // Update user profile directly
//     updateUserProfile: (state, action) => {
//       state.userProfile = {
//         ...state.userProfile,
//         ...action.payload
//       };
//     },
    
//     clearFormData: (state, action) => {
//       const formType = action.payload; // 'login' or 'register'
//       if (formType === 'login') {
//         state.formData.login = {
//           email: '',
//           username: '',
//           phone: ''
//         };
//       } else if (formType === 'register') {
//         state.formData.register = {
//           fullName: '',
//           email: '',
//           username: '',
//           contactNumber: '',
//           address: '',
//           city: '',
//           state: '',
//           zipCode: '',
//           country: '',
//           agreedToTerms: false
//         };
//       } else {
//         // Clear both
//         state.formData = {
//           login: {
//             email: '',
//             username: '',
//             phone: ''
//           },
//           register: {
//             fullName: '',
//             email: '',
//             username: '',
//             contactNumber: '',
//             address: '',
//             city: '',
//             state: '',
//             zipCode: '',
//             country: '',
//             agreedToTerms: false
//           }
//         };
//       }
//     }
//   },
// });

// export const { 
//   setUser,
//   setGoogleUser, // NEW: Export the new action
//   logout, 
//   setPlan, 
//   incrementPropertyCount, 
//   addProperty,
//   setCurrentConversationId,
//   setSenderId,
//   setReceiverId,
//   setConversations,
//   setLoginFormData,
//   setLoginField,
//   setRegisterFormData,
//   setRegisterField,
//   updateUserProfile,
//   clearFormData
// } = userSlice.actions;

// export const selectUser = (state) => state.user.user;
// export const selectIsAuthenticated = (state) => state.user.isAuthenticated;
// export const selectSubscription = (state) => state.user.subscription;
// export const selectProperties = (state) => state.user.properties;
// export const selectCurrentConversationId = (state) => state.user?.messaging?.currentConversationId;
// export const selectSenderId = (state) => state.user?.messaging?.senderId;
// export const selectReceiverId = (state) => state.user?.messaging?.receiverId;
// export const selectConversations = (state) => state.user?.messaging?.conversations;
// export const selectLoginFormData = (state) => state.user?.formData?.login;
// export const selectRegisterFormData = (state) => state.user?.formData?.register;
// export const selectUserProfile = (state) => state.user?.userProfile;

// export default userSlice.reducer;


import { createSlice } from '@reduxjs/toolkit';

// ❌ REMOVED: getUserFromStorage function - this was causing the issue

// ✅ UPDATED: Clean initial state without reading from localStorage
const initialState = {
  user: null, // Changed from getUserFromStorage() to null
  isAuthenticated: false, // Changed from !!getUserFromStorage() to false
  properties: [],
  subscription: {
    plan: 'free',
    propertiesAdded: 3,
    maxProperties: 999,
    coolingPeriod: null,
    listingDuration: null,
  },
  messaging: {
    currentConversationId: null,
    conversations: [],
    senderId: null,
    receiverId: null
  },
  formData: {
    login: {
      email: '',
      username: '',
      phone: ''
    },
    register: {
      fullName: '',
      email: '',
      username: '',
      contactNumber: '',
      address: '',
      city: '',
      state: '',
      zipCode: '',
      country: '',
      agreedToTerms: false
    }
  },
  userProfile: {
    fullName: '',
    email: '',
    contactNumber: '',
  }
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action) => {
      const userData = action.payload;
      
      // ✅ ADDED: Validation to prevent invalid user data
      if (!userData || !userData.id || !userData.token) {
        console.error('❌ Invalid user data - missing id or token:', userData);
        return;
      }

      // ✅ ADDED: Check if this is a different user and clear old data
      if (state.user && state.user.id && state.user.id !== userData.id) {
        console.warn('⚠️ Different user detected! Old:', state.user.id, 'New:', userData.id);
        localStorage.removeItem('auth_token');
        localStorage.removeItem('user_id');
        localStorage.removeItem('user_email');
        localStorage.removeItem('user_name');
      }

      state.user = userData;
      state.isAuthenticated = !!userData;

      if (userData && userData.token) {
        localStorage.setItem('auth_token', userData.token);
        if (userData.id) {
          localStorage.setItem('user_id', userData.id.toString());
        }
        if (userData.email) {
          localStorage.setItem('user_email', userData.email);
        }
        if (userData.fullName) {
          localStorage.setItem('user_name', userData.fullName);
        }
      }

      if (userData) {
        state.userProfile = {
          fullName: userData.fullName || '',
          email: userData.email || '',
          contactNumber: userData.contactNumber || '',
        };
      }

      if (!state.messaging) {
        state.messaging = {
          currentConversationId: null,
          conversations: [],
          senderId: null,
          receiverId: null
        };
      }

      console.log('✅ User set in Redux:', { id: userData.id, email: userData.email, fullName: userData.fullName });
    },

    setGoogleUser: (state, action) => {
      const googleData = action.payload;
      
      // ✅ ADDED: Validation for Google user data
      if (!googleData || !googleData.id) {
        console.error('❌ Invalid Google user data:', googleData);
        return;
      }

      console.log('🔐 Setting Google user with data:', googleData);

      // ✅ ADDED: Check if this is a different user
      if (state.user && state.user.id && state.user.id !== googleData.id) {
        console.warn('⚠️ Different Google user detected! Old:', state.user.id, 'New:', googleData.id);
        localStorage.clear();
      }

      const userData = {
        id: googleData.id,
        fullName: googleData.full_name,
        email: googleData.email_id,
        contactNumber: googleData.contact_number,
        token: googleData.token || localStorage.getItem('auth_token'),
        authProvider: googleData.auth_provider || 'google',
        googleId: googleData.google_id,
        profileImage: googleData.profile_image,
        location: googleData.location,
        occupation: googleData.occupation,
        professionalTitle: googleData.professional_title,
        companyName: googleData.company_name,
        yearsOfExperience: googleData.years_of_experience,
        licenseNumber: googleData.license_number,
        bio: googleData.bio,
        website: googleData.website,
        linkedin: googleData.linkedin,
        facebook: googleData.facebook,
      };

      state.user = userData;
      state.isAuthenticated = true;

      if (userData.token) {
        localStorage.setItem('auth_token', userData.token);
      }
      localStorage.setItem('user_id', userData.id.toString());
      localStorage.setItem('user_email', userData.email);
      localStorage.setItem('user_name', userData.fullName);

      state.userProfile = {
        fullName: userData.fullName,
        email: userData.email,
        contactNumber: userData.contactNumber || '',
      };

      if (!state.messaging) {
        state.messaging = {
          currentConversationId: null,
          conversations: [],
          senderId: null,
          receiverId: null
        };
      }

      console.log('✅ Google user set in Redux:', { id: userData.id, email: userData.email });
    },

    logout: (state) => {
      console.log('🚪 Logging out user:', state.user?.id);
      
      // ✅ UPDATED: Clear ALL localStorage including persist cache
      localStorage.removeItem('auth_token');
      localStorage.removeItem('user_id');
      localStorage.removeItem('user_email');
      localStorage.removeItem('user_name');
      localStorage.removeItem('persist:root'); // ✅ CRITICAL: Clear Redux Persist cache
      
      sessionStorage.clear();

      return {
        user: null,
        isAuthenticated: false,
        properties: [],
        subscription: {
          plan: 'free',
          propertiesAdded: 0,
          maxProperties: 3,
          coolingPeriod: null,
          listingDuration: null,
        },
        messaging: {
          currentConversationId: null,
          conversations: [],
          senderId: null,
          receiverId: null
        },
        formData: {
          login: {
            email: '',
            username: '',
            phone: ''
          },
          register: {
            fullName: '',
            email: '',
            username: '',
            contactNumber: '',
            address: '',
            city: '',
            state: '',
            zipCode: '',
            country: '',
            agreedToTerms: false
          }
        },
        userProfile: {
          fullName: '',
          email: '',
          contactNumber: '',
        }
      };
    },

    setPlan: (state, action) => {
      const plan = action.payload;
      let maxProperties = 3;
      let listingDuration = 0;
      let coolingPeriod = 0;

      switch (plan) {
        case 'basic':
          maxProperties = 10;
          listingDuration = 30;
          coolingPeriod = 30;
          break;
        case 'professional':
          maxProperties = 25;
          listingDuration = 90;
          coolingPeriod = 30;
          break;
        case 'enterprise':
          maxProperties = 999;
          listingDuration = 180;
          coolingPeriod = 30;
          break;
        default:
          maxProperties = 3;
          listingDuration = 15;
          coolingPeriod = 0;
      }

      state.subscription = {
        ...state.subscription,
        plan,
        maxProperties,
        listingDuration,
        coolingPeriod,
      };
    },

    incrementPropertyCount: (state) => {
      state.subscription.propertiesAdded += 1;
    },

    addProperty: (state, action) => {
      const propertyId = action.payload;
      if (!state.properties) state.properties = [];
      state.properties.push(propertyId);
    },

    setCurrentConversationId: (state, action) => {
      if (!state.messaging) {
        state.messaging = {
          currentConversationId: null,
          conversations: [],
          senderId: null,
          receiverId: null
        };
      }
      state.messaging.currentConversationId = action.payload;
    },

    setSenderId: (state, action) => {
      if (!state.messaging) {
        state.messaging = {
          currentConversationId: null,
          conversations: [],
          senderId: null,
          receiverId: null
        };
      }
      state.messaging.senderId = action.payload;
    },

    setReceiverId: (state, action) => {
      if (!state.messaging) {
        state.messaging = {
          currentConversationId: null,
          conversations: [],
          senderId: null,
          receiverId: null
        };
      }
      state.messaging.receiverId = action.payload;
    },

    setConversations: (state, action) => {
      if (!state.messaging) {
        state.messaging = {
          currentConversationId: null,
          conversations: [],
          senderId: null,
          receiverId: null
        };
      }
      state.messaging.conversations = action.payload;
    },

    setLoginFormData: (state, action) => {
      state.formData.login = {
        ...state.formData.login,
        ...action.payload
      };
    },

    setLoginField: (state, action) => {
      const { field, value } = action.payload;
      state.formData.login[field] = value;
    },

    setRegisterFormData: (state, action) => {
      state.formData.register = {
        ...state.formData.register,
        ...action.payload
      };
      if (action.payload.fullName) {
        state.userProfile.fullName = action.payload.fullName;
      }
      if (action.payload.email) {
        state.userProfile.email = action.payload.email;
      }
      if (action.payload.contactNumber) {
        state.userProfile.contactNumber = action.payload.contactNumber;
      }
    },

    setRegisterField: (state, action) => {
      const { field, value } = action.payload;
      state.formData.register[field] = value;

      if (field === 'fullName') {
        state.userProfile.fullName = value;
      } else if (field === 'email') {
        state.userProfile.email = value;
      } else if (field === 'contactNumber') {
        state.userProfile.contactNumber = value;
      }
    },

    updateUserProfile: (state, action) => {
      state.userProfile = {
        ...state.userProfile,
        ...action.payload
      };
    },

    clearFormData: (state, action) => {
      const formType = action.payload;
      if (formType === 'login') {
        state.formData.login = {
          email: '',
          username: '',
          phone: ''
        };
      } else if (formType === 'register') {
        state.formData.register = {
          fullName: '',
          email: '',
          username: '',
          contactNumber: '',
          address: '',
          city: '',
          state: '',
          zipCode: '',
          country: '',
          agreedToTerms: false
        };
      } else {
        state.formData = {
          login: {
            email: '',
            username: '',
            phone: ''
          },
          register: {
            fullName: '',
            email: '',
            username: '',
            contactNumber: '',
            address: '',
            city: '',
            state: '',
            zipCode: '',
            country: '',
            agreedToTerms: false
          }
        };
      }
    }
  },
});

export const {
  setUser,
  setGoogleUser,
  logout,
  setPlan,
  incrementPropertyCount,
  addProperty,
  setCurrentConversationId,
  setSenderId,
  setReceiverId,
  setConversations,
  setLoginFormData,
  setLoginField,
  setRegisterFormData,
  setRegisterField,
  updateUserProfile,
  clearFormData
} = userSlice.actions;

export const selectUser = (state) => state.user.user;
export const selectIsAuthenticated = (state) => state.user.isAuthenticated;
export const selectSubscription = (state) => state.user.subscription;
export const selectProperties = (state) => state.user.properties;
export const selectCurrentConversationId = (state) => state.user?.messaging?.currentConversationId;
export const selectSenderId = (state) => state.user?.messaging?.senderId;
export const selectReceiverId = (state) => state.user?.messaging?.receiverId;
export const selectConversations = (state) => state.user?.messaging?.conversations;
export const selectLoginFormData = (state) => state.user?.formData?.login;
export const selectRegisterFormData = (state) => state.user?.formData?.register;
export const selectUserProfile = (state) => state.user?.userProfile;

export default userSlice.reducer;